f
<template>
  <div :class="cn(cardVariants(), props.class)">
    <div class="flex truncate justify-between items-center gap-2">
      <div class="flex truncate gap-2 items-center">
        <Indicator
          variant="recurring-tasks"
          size="xs"
          :imageUrl="item.thumbnailUrl"
        />
        <div class="text-primary leading-6 text-lg font-medium truncate w-full">
          {{ item.description }}
        </div>
      </div>
    </div>

    <div class="flex w-full gap-3 justify-between truncate">
      <div class="flex w-full gap-1 truncate">
        <div class="shrink-0 flex items-center truncate">
          {{ item.tenant.name }}
        </div>
        <div
          v-if="!isEmpty(item.space)"
          class="flex items-center gap-1 truncate"
        >
          <Divider orientation="vertical" class="h-5.5" />
          <div class="truncate">
            {{ item.space.name }}
          </div>
        </div>
      </div>
      <Id
        v-if="item.rrule"
        :label="capitalize(item.rrule.frequency)"
        class="!max-w-24"
        size="sm"
      />
    </div>
  </div>
</template>

<script setup>
// Utils
import { cn } from "@/Utils/cn";
import { cardVariants } from ".";
import { isEmpty, capitalize } from "lodash";

// Components
import { Indicator } from "@/SharedComponents/Indicator";
import { Id } from "@/SharedComponents/Badges";
import { Divider } from "@/SharedComponents/Divider";

// Define Props
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  class: {
    type: null,
    required: false,
  },
});
</script>
